module.exports = __webpack_public_path__ + "img/phone.d9a48ba7.png";